// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__21ruF","type":"styles_type__3YMGi","choices":"styles_choices__1LoQD"};